<div class="cb-users-avatar-list" [cbPopover]="UsersList">
    <ng-container *ngTemplateOutlet="ContentTemplate"></ng-container>
</div>

<ng-template #ContentTemplate>
    @for (item of (filteredUsersIds() | slice:0:maxUsers()); track item) {
    @if(item){
    @if(enableAnimation()){
    <cb-user-avatar [avatarsList]="avatarsList()" [@userAnimation] [userId]="item" [size]="size()"
        [onlyAvatar]="true"></cb-user-avatar>
    }@else {
    <cb-user-avatar [avatarsList]="avatarsList()" [userId]="item" [size]="size()" [onlyAvatar]="true"></cb-user-avatar>
    }
    }
    }
    @if (filteredUsersIds().length > maxUsers()) {
    <p>+{{filteredUsersIds().length - maxUsers()}}</p>
    }
</ng-template>

<ng-template #UsersList>
    <div class="cb-users-avatar-details">
        @for (item of filteredUsersIds(); track item) {
        <cb-user-avatar [avatarsList]="avatarsList()" [onlyAvatar]="false" [userId]="item"
            [size]="'xs'"></cb-user-avatar>
        }
    </div>
</ng-template>